import { Container, Card, Table, Button, ButtonGroup, Form, Col } from "react-bootstrap";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
import { getHolidayYear } from "../../3.Store/HolidaySlice";
import { ThreeDots } from 'react-loader-spinner';

const HolidaysList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const roles = JSON.parse(localStorage.getItem("roles"));
  const isHR = roles.includes("HR-HOLIDAY");
  
  const getYearFromQuery = () => {
    const params = new URLSearchParams(location.search);
    const year = params.get('year');
    return year ? parseInt(year) : new Date().getFullYear();
  };

  const [selectedYear, setSelectedYear] = useState(getYearFromQuery());
  const holiday = useSelector(state => state.HolidaySlice.holidays);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(getHolidayYear({year: selectedYear}))
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [selectedYear]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Set the date format to '04 January 2020'
  function formatDate(dateString) {
      // Convert dateString to Date object
      return moment(dateString).format('DD MMMM YYYY');
  }

  // Handle Button
  const handleCreate = () => {
    navigate(`/HolidayForm?year=${selectedYear}`);
  };

  const handleUpdate = (id) => {
    navigate(`/HolidayForm/${id}?year=${selectedYear}`);
  };

  // Generate options for year dropdown (e.g., 2020-2024)
  const renderYearOptions = () => {
    const endYear = new Date().getFullYear() + 2;
    const startYear = endYear - 4;
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(<option key={year} value={year}>{year}</option>);
    }
    return years;
  };

  const handleBtnBack = () => {
    navigate("/");
  };

  return (
    <Container className="ContainerContent">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardHoliday">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>
        <h1 className="TitleHeader">Holidays</h1>

        <Col md={2} sm={1} style={{ marginLeft: "auto" }}>
          {/* Dropdown menu for selecting the year */}
          <Form.Select 
            value={selectedYear}
            onChange={(e) => setSelectedYear(parseInt(e.target.value))}
          >
            {renderYearOptions()}
          </Form.Select><br/>
        </Col>
        
        <div style={{ overflowX: 'auto', fontSize: "14px" }}>
          <Table>
            <thead style={{ cursor: "pointer" }}>
              <tr>
              {isMobile ? (
                <>
                  <th>Holidays</th>
                  {isHR && (
                    <th style={{ textAlign: 'center', verticalAlign: 'middle' }}>Action</th>
                  )}
                </>
              ) : (
                <>
                <th>Date</th>
                <th>Day</th>
                <th>Holiday</th>
                {isHR && (
                  <th style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    <FontAwesomeIcon icon={faPenToSquare} title="Action"/>
                  </th>
                )}
                </>
              )}
              </tr>
            </thead>
            {!loading && (
              <tbody>
                {holiday.map(({ id, date, description }, i) => {
                  return (
                    <tr key={i} style={{ cursor: "pointer" }}>
                      {isMobile ? (
                        <>
                          <td>
                            <div><strong>Date: </strong>{formatDate(date.date)}</div>
                            <div><strong>Day: </strong>{moment(date.date).format('dddd')}</div>
                            <div>{description}</div>
                          </td>
                          {isHR && (
                            <td onClick={() => handleUpdate(id)} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                              <FontAwesomeIcon icon={faPenToSquare} style={{ color: "blue" }} />
                            </td>
                          )}
                        </>
                      ) : (
                        <>
                          <td>{formatDate(date.date)}</td>
                          <td>{moment(date.date).format('dddd')}</td>
                          <td>{description}</td>
                          {isHR && (
                            <td onClick={() => handleUpdate(id)} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                              <FontAwesomeIcon icon={faPenToSquare} style={{ color: "blue" }} />
                            </td>
                          )}
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            )}
          </Table>
        </div>

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>

          {isHR && (
            <ButtonGroup className="my-2">
              <Button className="Button" onClick={() => handleCreate()}>
                Add
              </Button>
            </ButtonGroup>
          )}
        </div>

      </Card>
    </Container>
  );
};
export default HolidaysList;